<script>
  import {
    Card,
    CardBody,
  } from "sveltestrap";

</script>

<Card>
<CardBody>
  <div class="mb-4 h1 card-title">KLAID</div>
  
    <h3><span style="color: #F50">K</span>orean <span style="color: #F50">L</span>egal <span style="color: #F50">AI</span> <span style="color: #F50">D</span>atasets</h3>
    <p class="card-text h5">
      KLAID는 로앤컴퍼니가 자체 보유한 데이터를 기반으로 만든 ‘한국어 법률 AI 데이터셋’입니다.
    </p>
    <br/>
    <p class="card-text h5">
      2022. 11. 현재 '형사 범죄 분류'(Legal Judgment Prediction) 1개의 Task가 공개되어 있습니다.
    </p>
    <p class="card-text h5">앞으로 법률 AI 데이터셋 공개 범위를 넓혀 과제를 추가 공개하고, 주기적인 경진대회를 개최해 법률 AI 연구에 대한 일반 연구자의 관심을 확대해 나갈 계획입니다.  
    </p>
  
</CardBody>
</Card>

